export default __webpack_public_path__ + "static/media/CanYouSee_01.5e5a6393.png";